var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("rect", { x: "7", y: "6", width: "14", height: "14", rx: "1", stroke: "#303030", strokeWidth: "1.5" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.41602 16.376C3.21811 16.6728 2.78189 16.6728 2.58397 16.376L1.51823 14.7773C1.29671 14.4451 1.53491 14 1.93426 14L4.06574 14C4.46509 14 4.70328 14.4451 4.48177 14.7774L3.41602 16.376zM3.41602 9.62404C3.21811 9.32717 2.78189 9.32717 2.58397 9.62404L1.51823 11.2227C1.29671 11.5549 1.53491 12 1.93426 12L4.06574 12C4.46509 12 4.70328 11.5549 4.48177 11.2226L3.41602 9.62404z", fill: "#303030" }),
    React.createElement("path", { d: "M14 6V20", stroke: "#303030", strokeWidth: "1.5" }),
    React.createElement("path", { d: "M12 3H16", stroke: "#303030", strokeWidth: "1.5", strokeLinecap: "round" })
  );
});